module.exports = __webpack_public_path__ + "files/e368d8bb46ab4a68b7faec961e4e4b50.png";